import _jsx from '@babel/runtime/helpers/jsx';
import 'react';
import classNames from 'classnames';
import { Card, CardContent } from '@andes/card';
import { useVppContext } from '@vpp-frontend-components/vpp-context';
import { Icon } from '@vpp-frontend-components/icon';
import { StyledLabel } from '@vpp-frontend-components/styled-label';
import { ThumbnailMultiple, Thumbnail as Thumbnail$1 } from '@andes/thumbnail';
import { Image } from '@vpp-frontend-components/image';
const namespace$2 = 'ui-product-suggestions-information';

/**
 * Information component
 * @type {import('../../index.d.ts').InformationProps}
 */
const Information = _ref => {
  var _action$label;
  let {
    title,
    description,
    action
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: `${namespace$2}`
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: `${namespace$2}__content`
  }, void 0, (title === null || title === void 0 ? void 0 : title.text) && /*#__PURE__*/_jsx("div", {
    className: `${namespace$2}__content__title`
  }, void 0, /*#__PURE__*/_jsx(StyledLabel, {
    as: "p",
    text: title.text,
    color: title.color,
    font_family: title.font_family,
    font_size: title.font_size
  })), (description === null || description === void 0 ? void 0 : description.text) && /*#__PURE__*/_jsx("div", {
    className: `${namespace$2}__content__description`
  }, void 0, /*#__PURE__*/_jsx(StyledLabel, {
    as: "p",
    text: description.text,
    color: description.color,
    font_family: description.font_family,
    font_size: description.font_size
  }))), (action === null || action === void 0 ? void 0 : action.target) && (action === null || action === void 0 || (_action$label = action.label) === null || _action$label === void 0 ? void 0 : _action$label.text) && /*#__PURE__*/_jsx("div", {
    className: `${namespace$2}__target`
  }, void 0, /*#__PURE__*/_jsx(StyledLabel, {
    as: "a",
    className: `${namespace$2}__target__link`,
    href: action.target,
    text: action.label.text,
    color: action.label.color,
    font_family: action.label.font_family,
    font_size: action.label.font_size
  })));
};
const namespace$1 = 'ui-product-suggestions-thumbnail';

/**
 * Thumbnail component
 * @type {import('../..').ThumbnailProps}
 */
const Thumbnail = _ref => {
  let {
    pictures,
    moreLabel,
    type = 'stacked',
    containerSize = '32',
    modifier = 'circle'
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: `${namespace$1}`
  }, void 0, /*#__PURE__*/_jsx(ThumbnailMultiple, {
    type: type === null || type === void 0 ? void 0 : type.toLowerCase(),
    containerSize: containerSize,
    modifier: modifier === null || modifier === void 0 ? void 0 : modifier.toLowerCase(),
    overflow: moreLabel
  }, void 0, pictures.map(item => {
    var _item$url, _item$url2;
    return /*#__PURE__*/_jsx(Thumbnail$1, {}, (_item$url = item.url) === null || _item$url === void 0 ? void 0 : _item$url.src, /*#__PURE__*/_jsx(Image, {
      className: `${namespace$1}__image`,
      src: (_item$url2 = item.url) === null || _item$url2 === void 0 ? void 0 : _item$url2.src,
      alt: item.alt
    }));
  })));
};
const namespace = 'ui-product-suggestions';

/**
 * ProductSuggestions component
 * @type {import('../index.d.ts').ProductSuggestions}
 */
const ProductSuggestions = _ref => {
  let {
    className,
    content,
    thumbnails,
    action,
    background_color: backgroundColor,
    shadow = 'NONE',
    runCatchErrorBoundary = () => {}
  } = _ref;
  try {
    var _thumbnails$pictures, _action$icon, _action$icon2;
    /* eslint-disable react-hooks/rules-of-hooks */
    const {
      staticProps
    } = useVppContext();
    const {
      deviceType
    } = staticProps;
    const {
      title,
      description
    } = content || {};
    const borderColor = backgroundColor === 'GRADIENT_BLUE' ? 'LIGHT_BLUE' : 'LIGHT_GRAY';
    const cardClasses = classNames(className, namespace, `${namespace}--${deviceType}`, {
      [`${namespace}-background-color--${backgroundColor}`]: backgroundColor
    }, {
      [`${namespace}-border-color--${borderColor}`]: borderColor
    });
    return /*#__PURE__*/_jsx(Card, {
      className: cardClasses,
      paddingSize: 0,
      shadow: shadow === null || shadow === void 0 ? void 0 : shadow.toLowerCase()
    }, void 0, /*#__PURE__*/_jsx(CardContent, {}, void 0, /*#__PURE__*/_jsx("div", {
      className: `${namespace}__content`
    }, void 0, /*#__PURE__*/_jsx(Information, {
      title: title,
      description: description,
      action: action
    }), (thumbnails === null || thumbnails === void 0 || (_thumbnails$pictures = thumbnails.pictures) === null || _thumbnails$pictures === void 0 ? void 0 : _thumbnails$pictures.length) > 0 && /*#__PURE__*/_jsx(Thumbnail, {
      pictures: thumbnails.pictures,
      moreLabel: thumbnails.more_quantity,
      type: thumbnails.container_type,
      containerSize: thumbnails.container_size,
      modifier: thumbnails.container_style
    }), (action === null || action === void 0 ? void 0 : action.icon) && /*#__PURE__*/_jsx(Icon, {
      "data-testid": `${namespace}-icon`,
      id: (_action$icon = action.icon) === null || _action$icon === void 0 ? void 0 : _action$icon.id,
      className: `${namespace}-icon`,
      color: (_action$icon2 = action.icon) === null || _action$icon2 === void 0 ? void 0 : _action$icon2.color
    }))));
    /* eslint-enable react-hooks/rules-of-hooks */
  } catch (error) {
    /* istanbul ignore next */
    return runCatchErrorBoundary(error);
  }
};
ProductSuggestions.displayName = 'ProductSuggestions';
export { ProductSuggestions };
